import { z } from 'zod';

export const PortalFilteredDomainSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  portalId: z.number(),
  domain: z.string(),
  createdAt: z.date(),
});

export type PortalFilteredDomainDto = z.infer<typeof PortalFilteredDomainSchema>;

export const domainQuerySchema = z
  .string()
  .min(1)
  .max(255)
  .regex(
    /^@?[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/,
    'Invalid domain format. Expected format: @example.com',
  );

const domainSchema = z
  .string()
  .regex(
    /^@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/,
    'Invalid domain format. Expected format: @example.com',
  );

export const SetPortalFilteredDomainsSchema = z
  .object({
    domainFilteringEnabled: z.boolean(),
    domains: z.array(domainSchema).max(100),
  })
  .refine((data) => !data.domainFilteringEnabled || data.domains.length > 0, {
    message: 'At least one domain is required when filtering is enabled.',
    path: ['domains'],
  });

export type SetPortalFilteredDomainsDto = z.infer<typeof SetPortalFilteredDomainsSchema>;

export const CheckBlockedDomainResponseSchema = z.object({
  blocked: z.boolean(),
  customerName: z.string().optional(),
  warning: z.boolean().optional(),
});

export type CheckBlockedDomainResponseDto = z.infer<typeof CheckBlockedDomainResponseSchema>;

export const SetPortalFilteredDomainsResponseSchema = z.object({
  domainFilteringEnabled: z.boolean(),
  domains: z.array(z.string()),
  warnings: z.array(z.string()).optional(),
});

export type SetPortalFilteredDomainsResponseDto = z.infer<
  typeof SetPortalFilteredDomainsResponseSchema
>;
